export const MUTATIONS = {
  app: {
    updateSnackbar: "updateSnackbar",
    updateToastModal: "updateToastModal",
    dismissToast: "dismissToast",
    toggleSidebarStatus: "toggleSidebarStatus",
  },

  auth: {
    toggleLoading: "toggleLoading",
    toggleAuthenticationStatus: "toggleAuthenticationStatus",
    // register form
    updateRegisterMobile: "updateRegisterMobile",
    updateRegisterPassword: "updateRegisterPassword",
    updateRegisterConfirm: "updateRegisterConfirm",
  },

  panel: {
    updateActiveRoutePage: "updateActiveRoutePage",
    updateLoadingPanel: "updateLoadingPanel",
    setGlobalPagination: "setGlobalPagination",
    setGlobalActivePage: "setGlobalActivePage",
    resetGlobalPagination: "resetGlobalPagination"
  },
};
